export const getErrorMessage = (err: any, fallback: string): string => err?.response?.data?.message || fallback;
